import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddRefreshComponent } from './add-refresh/add-refresh.component';
import { AddNewComponent } from './add-new/add-new.component';
import {CoreModule} from '../../core/core.module';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
  declarations: [AddRefreshComponent, AddNewComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule
    ],
  exports: [
    AddRefreshComponent,
    AddNewComponent
  ],
    entryComponents: [
        AddNewComponent
    ]
})
export class AddRefreshModule { }
